/**
 * Convierte un valor de query de la ruta en id de cuenta para la descarga.
 * Si llega un array toma el primer valor; solo acepta enteros positivos seguros.
 *
 * @returns el id, o `undefined` si el valor no es un entero positivo
 */
export function toDownloadAccountId(value: unknown): number | undefined {
  const rawValue = Array.isArray(value) ? value[0] : value;

  if (typeof rawValue !== 'string' || !/^[1-9]\d*$/.test(rawValue)) return undefined;

  const accountId = Number(rawValue);

  return Number.isSafeInteger(accountId) ? accountId : undefined;
}
